import queryString from 'qs';
import { get } from 'lodash';
import { connect } from 'react-redux';
import BenchmarkBar from './BenchmarkBar';
import {
  saveAudienceSegment,
  selectBenchmark
} from '../../actions/audience-segment-actions';
import { selectBenchmarks } from '../../reducers/filters-reducer';

import { defaultActionsForMapDispatchToProps } from '../../utils/redux';

import './BenchmarkBar.css';

const mapStateToProps = state => {
  const query = queryString.parse(
    get(state, 'router.location.search', '').slice(1)
  );

  return {
    selectedUUID: get(query, 'benchmark', null),
    benchmarks: selectBenchmarks(state)
  };
};

const defaultActions = {
  onSave: saveAudienceSegment,
  selectBenchmark
};

// const mapStateToProps = defaultStateForMapStateToProps(defaultState);
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkBar);
